const base = (import.meta as any).env.VITE_API_BASE_URL || '';
const TOKEN_KEY = (import.meta as any).env.VITE_JWT_TOKEN_KEY || 'ziweiai_access_token';

function getAuthHeaders(): Record<string, string> {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

function buildUrl(path: string, params?: Record<string, any>): string {
  if (!params || Object.keys(params).length === 0) return `${base}${path}`;
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null) continue;
    usp.append(k, String(v));
  }
  const sep = path.includes('?') ? '&' : '?';
  return `${base}${path}${sep}${usp.toString()}`;
}

async function request(method: string, path: string, options: { params?: Record<string, any>; headers?: HeadersInit; body?: any } = {}) {
  const url = buildUrl(path, options.params);
  const resp = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
      ...(options.headers || {})
    },
    ...(options.body !== undefined ? { body: JSON.stringify(options.body) } : {})
  });

  const text = await resp.text();
  let data: any = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }

  if (!resp.ok) {
    const message = (data && typeof data === 'object' && data.message) ? data.message : (text || resp.statusText);
    throw new Error(message);
  }

  return { data, status: resp.status };
}

export const apiClient = {
  get: (path: string, options?: { params?: Record<string, any>; headers?: HeadersInit }) => request('GET', path, options || {}),
  post: (path: string, body?: any, options?: { params?: Record<string, any>; headers?: HeadersInit }) => request('POST', path, { ...(options || {}), body }),
  put: (path: string, body?: any, options?: { params?: Record<string, any>; headers?: HeadersInit }) => request('PUT', path, { ...(options || {}), body }),
  delete: (path: string, options?: { params?: Record<string, any>; headers?: HeadersInit }) => request('DELETE', path, options || {}),
  // 保留原有 postJSON 以兼容旧调用
  postJSON: async <T>(path: string, body: any): Promise<T> => {
    const res = await request('POST', path, { body });
    return res.data as T;
  }
};